import { User } from '../../models/User'
import React, { useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Modal } from '../../components/Modal/Modal'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { useDeleteExternalUserByIdMutation } from '../../store/externalUser/externalUser'
import { getUserDisplayName } from '../../apps/professional-app/fa/common/aifeatures/utils'

interface DeleteContactProps {
  user?: User
  show: boolean
  onDelete: () => void
  onCancel: () => void
}

export const DeleteContactModal: React.FC<DeleteContactProps> = ({ user, show, onDelete, onCancel }) => {
  const accountId = useAppSelector(selectAccountId)
  const [deleteUser, { isSuccess, isLoading }] = useDeleteExternalUserByIdMutation()
  const handleDeleteContact = async () => {
    if (user) {
      deleteUser({ accountId: accountId, userId: user.id })
    }
  }

  useEffect(() => {
    if (isSuccess) {
      onDelete()
    }
  }, [isSuccess])

  if (!user) {
    return null
  }

  const body = (
    <Container>
      <Row className='pb-3'>
        <Col>
          <h4 className='d-flex justify-content-center align-items-center'>Delete Contact</h4>
        </Col>
      </Row>
      <Row className='pb-4'>
        <Col className='p-0'>
          <div className='paragraph-medium'>
            Are you sure you want to delete contact <b>{getUserDisplayName(user)}</b> ?
          </div>
        </Col>
      </Row>
      <Row></Row>
    </Container>
  )
  return (
    <Modal
      show={show}
      onHide={onCancel}
      header={<></>}
      body={body}
      showFooterActions={true}
      onFooterPrimaryAction={handleDeleteContact}
      footerPrimaryActionLoading={isLoading}
      footerPrimaryActionTitle='Delete'
      footerPrimaryActionButtonVariant='danger'
    />
  )
}
